module.exports = __webpack_public_path__ + "static/media/motors.415de530.png";